import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, input } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { EnabledPipe } from "../../../helpers/enabledpipe/enabledpipe";
import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyDdosAutoMitigationCommand } from "../../../helpers/self-service/modify_ddos_auto_mitigation";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";

@Component({
  selector: "selfservice-ddos-auto-mitigation",
  templateUrl: "selfservice-ddos-auto-mitigation.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EnabledPipe, FormsModule, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceDdosAutoMitigation {
  protected subscription = input.required<{ subscriptionId: string }>();
  protected mitigationState = input.required<"enabled" | "disabled">();
  protected bus = input.required<EventEmitter<StartLoadMessage>>();

  protected newMitigationState = computed(() => (this.mitigationState() === "enabled" ? "disabled" : "enabled"));

  protected readonly buildCommand = () => {
    const action = SelfServiceCommandKeys.ModifyDdosAutoMitigation;
    const modify = new ModifyDdosAutoMitigationCommand(this.newMitigationState() === "enabled");
    const command = new SelfServiceCommand(this.subscription().subscriptionId, action);
    command.payload = modify;
    return { command, action };
  };
}
